let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1678j")).then(() => parcelRequire('gfWgh'));